module.exports = __webpack_public_path__ + "img/smartphone1.248bfca0.png";